export class Certificate {
  public readonly distinguishedName: string;

  constructor(
    public readonly selfSigned: boolean,
    public readonly subject: Record<string, string | string[]>,
    public readonly extra: any | null,
    public readonly issuer: Record<string, string | string[]>,
    public readonly validity: string,
    public readonly valid: boolean
  ) {
    this.distinguishedName = this.getDistinguishedName();
  }

  private getDistinguishedName(): string {
    const parts: string[] = [];

    for (const key in this.subject) {
      if (!Object.hasOwn(this.subject, key)) {
        continue;
      }

      if (Array.isArray(this.subject[key])) {
        for (const el of this.subject[key]) {
          parts.push(`${key}=${el}`);
        }

        continue;
      }

      parts.push(`${key}=${this.subject[key]}`);
    }

    return parts.join(', ');
  }
}
